/*
Author: Liubo
Date: 2018-09-05
Desc: Vuex 状态管理模块-登录状态。同时引入cache模块，当登录状态为true时，设置session缓存和user缓存。当挡路状态为false时，刷新session缓存，清空user缓存
*/
import cache from "@/assets/js/cache";
export default {
    state: {
        status: (sessionStorage.getItem("_b") === "1"),
        transid: sessionStorage.getItem("_t") || ""
    },
    getters: {},
    mutations: {
        SET_STATUS (state, val) {
            state.status = val;
            if (val === true) {
                sessionStorage.setItem("_b", "1");
                localStorage.setItem("_b", "1");
            } else {
                sessionStorage.removeItem("_b");
                localStorage.removeItem("_b");
            }
        },
        SET_TRANSID (state, val) {
            state.transid = val;
            sessionStorage.setItem("_t", val);
        }
    },
    actions: {
        putTransid (context, id) {
            return new Promise((resolve, reject) => {
                context.commit("SET_TRANSID", id);
                resolve();
            });
        },
        login (context, loginData) {
            return new Promise((resolve, reject) => {
                context.commit("SET_STATUS", true);
                sessionStorage.setItem("alreadyread","");
                cache.setSession({
                    token: loginData.token,
                    key: loginData.key
                });
                cache.refresh("_user").then(res => {
                    cache.setUser(res[0] || {user: "not"});
                    resolve();
                });
            });
        },
        logout (context, loginData) {
            return new Promise((resolve, reject) => {
                context.commit("SET_STATUS", false);
                cache.clearUser();
                if (loginData) {
                    cache.setSession(loginData);
                    resolve();
                } else {
                    cache.setSession();
                    cache.refresh("_session").then(res => {
                        resolve(res);
                    }).catch(err => reject(err));
                }
            });
        }
    }
};
